export default __webpack_public_path__ + "static/media/screen4.71c66bf6.png";